const internet = {
  its_seems_no_internet: "It looks like you're not connected to the internet",
  internet_connection_restored: "Restored internet connection",
};
export default internet;
